import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledFiltersSelected = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;

  & .link-container {
    margin-left: 10px;
  }
`;

export const StyledFilterChip = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  background-color: transparent;
  border: 1px solid ${theme.colors.black};
  height: ${theme.variables.height_1};
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  box-sizing: border-box;
  cursor: pointer;
  white-space: nowrap;
  padding: 12px 15px;
`;
